import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export interface HierarchicalItem {
  id: string;
  parentId?: string;
  order?: number;
  [key: string]: any;
}

export function getSortedHierarchicalCategories<T extends HierarchicalItem>(cats: T[]): { item: T; depth: number }[] {
  const catIds = new Set(cats.map(c => c.id));
  const rootCats = cats.filter(c => !c.parentId || !catIds.has(c.parentId)).sort((a, b) => (a.order || 0) - (b.order || 0));
  const result: { item: T; depth: number }[] = [];
  
  const traverse = (parentId: string, depth: number) => {
    const children = cats.filter(c => c.parentId === parentId).sort((a, b) => (a.order || 0) - (b.order || 0));
    children.forEach(child => {
      result.push({ item: child, depth });
      traverse(child.id, depth + 1);
    });
  };

  rootCats.forEach(root => {
    result.push({ item: root, depth: 0 });
    traverse(root.id, 1);
  });

  return result;
}

